import MyUpgradeReviewsPage from "./pages/MyUpgradeReviewsPage";
import ChairmanUpgradeApplicationsPage from "./pages/ChairmanUpgradeApplicationsPage";
import MyEntryReviewsPage from "./pages/MyEntryReviewsPage";
import ChairmanEntryApplicationsPage from "./pages/ChairmanEntryApplicationsPage";

// Gated by the Membership Committee's Spatie roles (roleSlug()):
//   committee_membership_committee           → a committee member
//   committee_membership_committee.chairman  → the chairman
export const committeeReviewRoutes = [
  {
    path: "/committee/upgrade-reviews",
    element: <MyUpgradeReviewsPage />,
    roles: ["committee_membership_committee", "committee_membership_committee.chairman"],
  },
  {
    path: "/committee/upgrade-applications",
    element: <ChairmanUpgradeApplicationsPage />,
    roles: ["committee_membership_committee.chairman"],
  },
  // The same committee also reviews ENTRY (probationer) applications.
  {
    path: "/committee/entry-reviews",
    element: <MyEntryReviewsPage />,
    roles: ["committee_membership_committee", "committee_membership_committee.chairman"],
  },
  {
    path: "/committee/entry-applications",
    element: <ChairmanEntryApplicationsPage />,
    roles: ["committee_membership_committee.chairman"],
  },
];
